import { render, staticRenderFns } from "./MultipleFile.vue?vue&type=template&id=8a113a66&scoped=true"
import script from "./MultipleFile.vue?vue&type=script&lang=js"
export * from "./MultipleFile.vue?vue&type=script&lang=js"
import style0 from "./MultipleFile.vue?vue&type=style&index=0&id=8a113a66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a113a66",
  null
  
)

export default component.exports